import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
  type: "all",
};

export const SearchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchValue: (state, action) => {
      state.value = action.payload.value;
    },
    setSearchType: (state, action) => {
      state.type = action.payload.type;
    },
    resetSearch: () => {
      console.log("resetSearch called");
      return { ...initialState }; // Tạo bản sao mới của initialState để redux reset
    },
  },
});

export const { setSearchValue, setSearchType, resetSearch } =
  SearchSlice.actions;

export default SearchSlice.reducer;
